var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_89_1651)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.461487H24V16.259H0V0.461487Z",
    fill: "#C60C30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.88889 0.461487H6.08187V6.92829H0V9.69977H6.08187V16.259H8.88889V9.69977H24V6.92829H8.88889V0.461487Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_89_1651"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 15.7975,
    fill: "white",
    transform: "translate(0 0.461487)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDk);
export default __webpack_public_path__ + "static/media/DK.7633a70e3431a260f86703f1a17874c0.svg";
export { ForwardRef as ReactComponent };